'use client';

import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useEffect,
} from 'react';
import { ApolloProvider } from '@apollo/client';
import { makeApolloClient } from '@/apollo';

interface ApiContextData {
  initialized: boolean;
  setToken: (token: string | null) => void;
}

const initialValue: ApiContextData = {
  initialized: false,
  setToken: () => undefined,
};

const ApiContext = createContext<ApiContextData>(initialValue);

export const ApiContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [initialized, setInitialized] = useState<boolean>(false);

  const [token, setToken] = useState<string | null>(null);

  const client = useMemo(() => makeApolloClient(token), [token]);

  useEffect(() => {
    setInitialized(!!token);
  }, [token]);

  return (
    <ApiContext.Provider
      value={{
        initialized,
        setToken,
      }}
    >
      <ApolloProvider client={client}>{children}</ApolloProvider>
    </ApiContext.Provider>
  );
};

export const useApi = () => useContext(ApiContext);
